import { Grid } from '@mui/material'

import { DriverCancellationsMetricCard } from './DriverCancellationsMetricCard'
import { JobsCompletedWithoutInterventionMetricCard } from './JobsCompletedWithoutInterventionMetricCard'
import { ManualInterventionsMetricCard } from './ManualInterventionsMetricCard'
import { OperationsNotesMetricCard } from './OperationsNotesMetricCard'

export const ExceptionMetricsCards = () => (
  <Grid container spacing={3}>
    <Grid item xs={12}>
      <OperationsNotesMetricCard />
    </Grid>
    <Grid item xs={12}>
      <DriverCancellationsMetricCard />
    </Grid>
    <Grid item xs={12}>
      <JobsCompletedWithoutInterventionMetricCard />
    </Grid>
    <Grid item xs={12}>
      <ManualInterventionsMetricCard />
    </Grid>
  </Grid>
)
